import AccountCreation from "@/components/signup/account-creation";

const UniformSignUpForm = () => {
    return <AccountCreation Login={null} />;
};

export default UniformSignUpForm;
